import React from "react";

const Payment = () => {
  return <div className="mt-5">Order preparing......</div>;
};

export default Payment;
